var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 73C146 113.317 113.317 146 73 146C32.6832 146 0 113.317 0 73C0 32.6832 32.6832 0 73 0C113.317 0 146 32.6832 146 73Z",
    fill: "#E50000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6914 34L80.168 90.0156H65.8711L64.3086 34H81.6914ZM73.0195 115.016C70.4414 115.016 68.2279 114.104 66.3789 112.281C64.5299 110.432 63.6185 108.219 63.6445 105.641C63.6185 103.089 64.5299 100.901 66.3789 99.0781C68.2279 97.2552 70.4414 96.3438 73.0195 96.3438C75.4935 96.3438 77.668 97.2552 79.543 99.0781C81.418 100.901 82.3685 103.089 82.3945 105.641C82.3685 107.359 81.9128 108.935 81.0273 110.367C80.168 111.773 79.0351 112.906 77.6289 113.766C76.2226 114.599 74.6862 115.016 73.0195 115.016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamation);
export default __webpack_public_path__ + "static/media/errorExclamation.40134d7eba89acd95e61e74a3781867b.svg";
export { ForwardRef as ReactComponent };